import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./NewsletterSection.css";
import envelopeIcon from "../../../assets/newsletter/email-envelope-white-icon.png"; // replace with your envelope icon

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const inputRef = useRef(null);

  // auto-dismiss overlay after 3s
  useEffect(() => {
    let timer;
    if (showThankYou) {
      timer = setTimeout(() => setShowThankYou(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [showThankYou]);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setEmail("");
    setShowThankYou(true);
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-content">
        <div className="newsletter-left">
          <img src={envelopeIcon} alt="" className="newsletter-icon" />
          <div className="newsletter-text">
            <h2>Subscribe for Newsletter</h2>
            <p>Get the latest ASIC design & verification insights delivered to your inbox.</p>
          </div>
        </div>
        <form className="newsletter-form" onSubmit={handleSubscribe}>
          <input
            ref={inputRef}
            type="email"
            required
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit">Subscribe</button>
        </form>
      </div>

      <AnimatePresence>
        {showThankYou && (
          <motion.div
            className="thankyou-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowThankYou(false)}
          >
            <motion.div
              className="thankyou-box"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <motion.svg
                className="thankyou-check"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1, ease: "easeInOut" }}
              >
                <circle cx="26" cy="26" r="25" stroke="#4caf50" strokeWidth="2" />
                <path
                  d="M16 27.5L23 34.5L36 19.5"
                  stroke="#4caf50"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </motion.svg>
              <h3>Thank you!</h3>
              <p>You’ve successfully subscribed.</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}